import {Injectable} from "@angular/core";
import {GenericService} from "../../core/commons/generic.service";
import {Province} from "../domain/province";
import {QueryOptions} from "../../core/commons/query.options";
import {AuthHttp} from "angular2-jwt";
import {AuthService} from "../../core/security/auth.service";

@Injectable()
export class ProvinceService extends GenericService<Province> {

    private provinceUrl = "/provinces";

    constructor(authService: AuthService) {
        super(authService)
    }

    protected valueToEntity(value: Object): Province {
        return new Province(value);
    }

    protected getResourcePath(): string {
        return this.provinceUrl;
    }

    getDefaultQueryOptions(): QueryOptions {
        return new QueryOptions();
    }

}



// WEBPACK FOOTER //
// ./src/app/profile/service/province.service.ts